import { Model } from '@nozbe/watermelondb';
import { field, relation } from '@nozbe/watermelondb/decorators';
import { LAST_SYNC_SCHEMA } from '../schema';

export default class LastSync extends Model {
    static table = LAST_SYNC_SCHEMA;

    static associations = {
        user: { type: 'belongs_to', key: 'user_id' },
    }

    @field('last_sync_at') last_sync_at;

    @relation('user', 'user_id') user;
}